import { useEffect, useState } from "react";
import { TextInput } from "lcm-iot-commons";

import withZxcvbn, {
  CheckPasswordResult,
  zxcvbnShape,
} from "../../wrappers/withZxcvbn";

const DEFAULT_STATE: CheckPasswordResult = {
  success: null,
  error: null,
  suggestions: [],
};

type OwnProps = {
  checkPassword?: boolean;
  name: string;
  touched: $TSFixMe;
  values?: Record<string, string>;
  setFieldValue: $TSFixMeFunction;
  zxcvbn: zxcvbnShape;
  userDetails?: {
    email?: string;
    first_name?: string;
    last_name?: string;
  };
};

const defaultProps: Partial<OwnProps> = {
  checkPassword: true,
  values: undefined,
  userDetails: {},
};

type Props = OwnProps & typeof defaultProps;

export function PasswordInput(props: Props) {
  const {
    values,
    name,
    zxcvbn,
    touched,
    setFieldValue,
    userDetails,
    checkPassword,
  } = props;
  const [state, setState] = useState(DEFAULT_STATE);

  const onPasswordPaste = (e: ClipboardEvent) => {
    const clipboardData =
      e.clipboardData ||
      /* istanbul ignore next */ (window as $TSFixMe).clipboardData;
    if (!clipboardData) return true; // use default behaviour

    e.preventDefault();
    const text = clipboardData.getData("text").replace(/[\n\r]/g, "");
    setFieldValue(name, text);
    return false;
  };

  useEffect(() => {
    if (checkPassword && values?.[name]?.length) {
      const extractedUserInputs = zxcvbn.extractUserInputs(values, [
        name,
        "captcha",
        "password",
      ]);
      const userInputs = extractedUserInputs.concat([
        userDetails?.email || "",
        userDetails?.first_name || "",
        userDetails?.last_name || "",
      ]);
      const result = zxcvbn.checkPassword(values[name], userInputs);
      setState(result);
    } else {
      setState(DEFAULT_STATE);
    }
  }, [values, name, touched]);

  const { success, suggestions } = state;
  touched[name] = touched[name] || values?.[name]?.length;

  return (
    <TextInput
      {...props}
      type="password"
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      success={success}
      moreAlerts={suggestions}
      onPaste={onPasswordPaste}
    />
  );
}

PasswordInput.defaultProps = defaultProps;

export default withZxcvbn(PasswordInput);
